
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sellers",
      function () {
        return require("private-next-pages/sellers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sellers"])
      });
    }
  